import React, { useEffect } from 'react';

const VerificationNotification = ({ code, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 10000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div
      style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        background: 'linear-gradient(to right, #7c3aed, #db2777)',
        color: 'white',
        padding: '16px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        zIndex: 9999,
        fontFamily: 'system-ui, -apple-system, sans-serif',
        maxWidth: '300px',
        animation: 'slideIn 0.3s ease-out'
      }}
    >
      <div style={{ marginBottom: '8px', fontWeight: 600 }}>
        {type === 'email' ? '📧' : '📱'} Verification Code (Development Only)
      </div>
      <div style={{ 
        fontSize: '24px', 
        fontWeight: 'bold', 
        letterSpacing: '2px', 
        marginBottom: '8px',
        background: 'rgba(255,255,255,0.1)',
        padding: '8px',
        borderRadius: '4px',
        textAlign: 'center'
      }}>
        {code}
      </div>
      <div style={{ fontSize: '12px', opacity: 0.8 }}>
        This would be sent via {type === 'email' ? 'email' : 'SMS'} in production
      </div>
      <button
        onClick={onClose}
        style={{
          position: 'absolute',
          top: '8px',
          right: '8px',
          background: 'none',
          border: 'none',
          color: 'white',
          cursor: 'pointer',
          fontSize: '18px',
          padding: '4px',
          opacity: 0.7
        }}
      >
        ×
      </button>
    </div>
  );
};

export default VerificationNotification;
